import assign from 'lodash/assign';

import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    singleListing: false,
    monthlySummariesUnavailable: false,
    dailyBillableCountsAvailable: false,
    monthlyBillableCountsAvailable: false,
    dailyListingStatsByYyyyMmDd: {},
    dailyListingStats: {},
    monthlyListingStatsByYyyyMm: {},
});

const statistic = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.STATS_GET_SUCCESS:
            return assign({}, state, payload);

        case DispatchConstants.STATS_GET_FAIL:
            return state;

        default:
            return state;
    }
};

export default statistic;
